import React, { useState } from "react";

function DownloadIcon(props: React.SVGProps<SVGSVGElement>) {
  const [isHovered, setIsHovered] = useState(false);

  const handlePressIn = () => {
    setIsHovered(true);
  };

  const handlePressOut = () => {
    setIsHovered(false);
  };

  const svgColor = isHovered ? "red" : "blue";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 122.88 110.9"
      {...props}
    >
      <path
        d="M13.09 35.65h30.58V23.2h34.49v12.45h31.47L61.39 82.58l-48.3-46.93zm48.35 62.23 47.51-.14 4.54-21.51 9.38.31v34.36H0V76.55l9.39-.31 4.54 21.51 47.51.13zM43.67 0h34.49v4.62H43.67V0zm0 9.32h34.49v9.44H43.67V9.32z"
        fill="#2d6289"
        style={{
          fillRule: "evenodd",
          clipRule: "evenodd",
        }}
      />
    </svg>
  );
}

export default DownloadIcon;
